module.exports = __webpack_public_path__ + "img/mypage__recommand__img.5accddcd.svg";